export function getHomeData(data) {
  return this.fetch({
    method: 'post',
    url: 'api/home',
    data
  })
}
export function getHomeLine(data) {
  return this.fetch({
    method: 'post',
    url: 'api/homeLine'
  })
}
export function getHomeMap(data) {
  return this.fetch({
    method: 'post',
    url: 'api/homeMapData'
  })
}
export function getHomeOrder(data) {
  return this.fetch({
    method: 'post',
    url: 'api/homeOrderList'
  })
}
export function getChangeLog() {
  return this.fetch({
    method: 'get',
    url: 'api/admin/sysVersionContents/getLatestVersion'
  })
}
